const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

class MarqueeRow extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-marquee-viewport]');
    this.track = this.querySelector('[data-marquee-track]');
    this.baseGroup = this.querySelector('[data-marquee-group]');
    if (!this.track || !this.baseGroup) return;

    this.speed = parseFloat(this.dataset.speed);
    if (Number.isNaN(this.speed)) this.speed = 30;

    this.layout = this.layout.bind(this);
    this.scheduleLayout = this.scheduleLayout.bind(this);

    window.addEventListener('resize', this.scheduleLayout);
    reducedMotion.addEventListener('change', this.scheduleLayout);

    this.scheduleLayout();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(this.scheduleLayout);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.scheduleLayout);
    reducedMotion.removeEventListener('change', this.scheduleLayout);
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  get isPaused() {
    return (
      this.speed <= 0 ||
      reducedMotion.matches ||
      (window.Shopify && window.Shopify.designMode)
    );
  }

  scheduleLayout() {
    if (this.frame) cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(this.layout);
  }

  layout() {
    this.frame = null;

    this.track.classList.remove('marquee__track--animated');
    this.track.querySelectorAll('[data-marquee-clone]').forEach((node) => node.remove());

    const groupWidth = this.baseGroup.getBoundingClientRect().width;
    if (groupWidth <= 0) return;

    if (this.isPaused) return;

    const viewportWidth = this.viewport.getBoundingClientRect().width;
    const copies = Math.max(2, Math.ceil(viewportWidth / groupWidth) + 1);
    for (let i = 1; i < copies; i += 1) {
      const clone = this.baseGroup.cloneNode(true);
      clone.setAttribute('data-marquee-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      this.track.appendChild(clone);
    }

    const pxPerSecond = this.speed * 2;
    const duration = groupWidth / pxPerSecond;
    this.track.style.setProperty('--marquee-shift', `${groupWidth}px`);
    this.track.style.setProperty('--marquee-duration', `${duration}s`);
    this.track.classList.add('marquee__track--animated');
  }
}

if (!customElements.get('marquee-row')) {
  customElements.define('marquee-row', MarqueeRow);
}
